import { jsx } from "react/jsx-runtime";
import React__default, { useContext, createContext, useMemo } from "react";
const FocusedFieldContext = createContext(
  void 0
);
const FocusedFieldProvider = ({
  children
}) => {
  const [focusedFieldId, setFocusedFieldId] = React__default.useState(void 0);
  const contextValue = useMemo(() => {
    return {
      focusedFieldId,
      setFocusedFieldId
    };
  }, [focusedFieldId, setFocusedFieldId]);
  return /* @__PURE__ */ jsx(FocusedFieldContext.Provider, { value: contextValue, children });
};
function useFocusedField() {
  const context = useContext(FocusedFieldContext);
  if (context === void 0) {
    throw new Error(
      "useFocusedField must be used within a FocusedFieldProvider"
    );
  }
  return context;
}
export {
  FocusedFieldProvider,
  useFocusedField
};
//# sourceMappingURL=focused-field-provider.js.map
